import Carousel from './Carousel';
import CarouselList from './CarouselList';
import SideCarouselContainer from './SideCarouselContainer';

export default Object.assign(Carousel, {
  List: CarouselList,
  SideContainer: SideCarouselContainer,
});